export default __webpack_public_path__ + "static/media/background-hub.affb0fa5.svg";